import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { AuthModalProvider } from './contexts/AuthModalContext';
import { PhoneVerificationModalProvider } from './contexts/PhoneVerificationModalContext';
import { ensureDeviceFp } from './services/deviceFingerprint';
import './styles/globals.css';

// 反盗版：应用启动即预热设备指纹（异步，不阻塞渲染），后续请求拦截器命中缓存即时附带
void ensureDeviceFp();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
        <AuthProvider>
          <AdminAuthProvider>
            <AuthModalProvider>
              <PhoneVerificationModalProvider>
                <App />
              </PhoneVerificationModalProvider>
            </AuthModalProvider>
          </AdminAuthProvider>
        </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
